<div class="flex flexColumn">
  @if (searchTitle && searchTitle.trim() !== '') {
    <span class="searchTitle">{{searchTitle}}</span>
  } @else {
    <span class="searchTitle">All Activities</span>
  }
  
  <div class="flex mt-3 mb-3" style="width: 100%; max-width: 600px;">
    <input
      type="text"
      class="form-control"
      placeholder="Search activities by name, description, or tags..."
      [(ngModel)]="searchText"
      (input)="onSearchChange()"
      style="padding: 8px 12px; font-size: 16px; border: 1px solid #ccc; border-radius: 4px;"
    />
  </div>
  
  <!-- <div class="flex spaceBetween" style="margin-top: 10px; margin-bottom: 10px;">
  <div class="flex">
    <app-vertical-dropdown-menu
      class="filterMenuSpacer"
      menuType="cashFilter"
      menuTitle="Price"
      [medianActivityPrice]="medianPrice"
      buttonClass="drop-menu-button-border"
      [displayMenu]="true"
    ></app-vertical-dropdown-menu>
    <app-vertical-dropdown-menu
      class="filterMenuSpacer"
      menuType="languageFilter"
      menuTitle="Language"
      [menuItems]="languages"
      [displayMenu]="true"
      buttonClass="drop-menu-button-border"
    ></app-vertical-dropdown-menu>
    <app-vertical-dropdown-menu
      class="filterMenuSpacer"
      menuType="durationFilter"
      menuTitle="Duration"
      [menuItems]="durations"
      [displayMenu]="true"
      buttonClass="drop-menu-button-border"
    ></app-vertical-dropdown-menu>
    <app-vertical-dropdown-menu
      class="filterMenuSpacer"
      menuType="timeFilter"
      menuTitle="Time"
      [menuItems]="times"
      [displayMenu]="true"
      buttonClass="drop-menu-button-border"
    ></app-vertical-dropdown-menu>
  </div>
  <div>
    <app-vertical-dropdown-menu
      menuTitle="Filters Allied"
      [displayMenu]="true"
      buttonClass="drop-menu-button-border"
    ></app-vertical-dropdown-menu>
  </div>
</div> -->
<div class="mt-3">
  @if (filteredActivities.length === 0) {
    <div class="flex justify-content-center" style="padding: 40px;">
      <p>No activities found. Try adjusting your search or filters.</p>
    </div>
  } @else {
    <div class="flex activitySection spaceBetween">
      @for (activity of filteredActivities; track activity.id) {
        <app-activity
          style="margin-right: 2px;"
          [activity]="activity"
        ></app-activity>
      }
    </div>
  }
</div>
</div>
